import { createAsyncThunk, createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "core/presentation/store";
import { fleetModuleContainer } from "fleet/FleetModule";
import FleetUseCase from "../../application/FleetUseCase";
import { message } from "antd";

const initialState: any = {
  vehicleCategories: [],
  vehicleCategory: {},
  units: [],
  vehicle: {},
  vehicles: [],
  vehicleOwner: [],
  shiftChangeRequests: [],
  shiftChangeRequestsCount: 0,
  VehicleCategoryCount: 0,
  vehicleTypes: [],
  vehicleType: {},
  trips: [],
  vehiclePlateColors: [],
  declinedVehicleReport: [],
  rejectedVehicleReport: [],
  editRequestvehicleReport: [],
  awaitingApprovalVehicleReport: [],
  tripDetails: {},
  insuranceCompany: [],
  unAssignedDriver: [],
  vehicleTypeCount: 0,
  vehicleChecklistCount: 0,
  declinedVehicleReportCount: 0,
  rejectedVehicleReportCount: 0,
  editRequestvehicleReportCount: 0,
  awaitingApprovalDriverReportCount: 0,
  awaitingApprovalVehicleReportCount: 0,
  tqmsOnBoardingData: [],
  tqmsOnBoardingDataCount: 0,
  vehicleOnBoardingList: [],
  vehicleOnBoardingListCount: 0,
  sthaniya: [],
  tmqsPendingVehicles: [],
  tqmsPendingVehiclesCount: 0,
  loadBoardPendingVehicles: [],
  loadBoardPendingVehiclesCount: 0,
  isLoading: false,
  error: null,
  completedTrips: [],
  completedTripsCount: 0,
  virtualCheckpointList: [],
  virtualCheckpointCount: 0,
  subscriptionExpiryReminders: [],
  applicablePromoCodes: [],
  applicablePromoCount: 0,
  appliedPromoCodes: [],
  appliedPromoCount: 0,
};

export const createVehicleCategoryThunk = createAsyncThunk<any, any, { state: RootState }>("fleet/createVehicleCategory", async (data: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.createVehicleCategory(data);
  return response;
});

export const getAllVechilesThunk = createAsyncThunk<any, { page: number; input: string; filter: string; report?: string; limit?: number }, { state: RootState }>("auth/vehicles", async ({ page, input, filter, report, limit }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAllVechiles(page, input, filter, report ?? "", limit ?? 10);
  return response;
});

export const getAllVehiclesOfDriverThunk = createAsyncThunk<any, { driverId: number }, { state: RootState }>("auth/vehicles-for-driver", async ({ driverId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAllVehiclesOfDriver(driverId);
  return response;
});

export const getAVehicleThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/vehicle", async (id: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAVehicle(id);
  return response.data;
});

export const deleteVehicleThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/deleteVehicle", async (id: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.deleteVehicle(id);
  return response;
});

export const getAllVehicleCategoryThunk = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("vehicle/vehicleCategories", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAllVehicleCategory(page, input, filter);
  return response;
});

export const deleteVehicleCategoryThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/deleteVehicleCategory", async (id: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.deleteVehicleCategory(id);
  return response.data;
});

export const getVehicleCategoryThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/vehicleCategory", async (id: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getVehicleCategory(id);
  return response.data;
});

export const updateVehicleCategoryThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/updateVehicleCategory", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.updateVehicleCategory(id, values);
  return response;
});

export const changeVehicleRequestStatusThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/changeVehicleStatus", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.changeVehicleRequestStatus(id, values);
  return response;
});

export const updateVehicleThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/updateVehicle", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.updateVehicle(id, values);
  return response;
});

export const getUnitsThunk = createAsyncThunk<any, void, { state: RootState }>("vehicle/getUnits", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getUnits();
  return response;
});

export const createUnitThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/createUnit", async (values) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.createUnit(values);
  return response;
});

export const createVehicleTypesThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/createVehicleType", async (values) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.createVehicleTypes(values);
  return response;
});

export const updateVehicleTypesThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/updateVehicleType", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.updateVehicleTypes(id, values);
  return response;
});

export const getAllVehicleTypesThunk = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("vehicle/getAllVehicleTypes", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAllVehicleTypes(page, input, filter);
  if (page <= 0) {
    return { data: response, skipStateUpdate: true };
  }

  return response;
});

export const getVehicleTypeThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/getVehicleType", async (id: number) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getVehicleType(id);
  return response;
});

export const getATripThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/getATrip", async ({ id, showMap }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getATrip(id, showMap ?? false);
  return response;
});

export const getAllVehicleOwnerList = createAsyncThunk<any, void, { state: RootState }>("vehicle/getVehicleOwners", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getAllVehicleOwnerList();
  return response;
});

export const deleteVehicleTypeThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/deleteVehicleType", async (id: number) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.deleteVehicleType(id);
  return response;
});

export const deleteTripThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/deleteTrip", async (id: number) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.deleteTrip(id);
  return response;
});

export const updateTripThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/updateTrip", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.updateTrip(id, values);
  return response;
});

export const getAllChangeShiftRequestsThunk = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("vehicle/shiftChangeRequests", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAllChangeRequests(page, input, filter);
  return response;
});

export const changeVehicleOwnThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/changeVehicleOwn", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.changeVehicleOwn(id, values);
  return response;
});

export const changeVehicleOthersThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/changeVehicleOthers", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.changeVehicleOthers(id, values);
  return response;
});

export const getTripCoordinatesById = createAsyncThunk<any, any, { state: RootState }>("vehicle/getTripCoordinates", async (id: number) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getTripCoordinatesById(id);
  return response;
});

export const getAllVehiclePlateColorsThunk = createAsyncThunk<any, void, { state: RootState }>("vehicle/getAllVehiclePlateColors", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getAllVehiclePlateColors();
  return response;
});

export const getVehiclePolicyTypesThunk = createAsyncThunk<any, void, { state: RootState }>("vehicle/getVehiclePolicyTypes", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getVehiclePolicyTypes();
  return response;
});

export const createVehicleThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/createVehicle", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.createVehicle(values);
  return response;
});

export const createTripThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/createTrip", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.createTrip(values);
  return response;
});

export const checkVehicleExistanceThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/checkVehicle", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.checkVehicleExistance(values);
  return response;
});

export const transferOwnershipThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/transfer-ownership", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.transferOwnership(values);
  return response;
});

export const updateTripStatusThunk = createAsyncThunk<any, { id: any; tripStatus: string }, { state: RootState }>("vehicle/updateTripStatus", async ({ id, tripStatus }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.updateTripStatus(id, tripStatus);
  return response;
});

export const getAllTripThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/trips", async ({ page, input, filter, ongoing, createdOnly }: { page: number; input: string; filter: string; ongoing?: string; createdOnly?: boolean }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getAllTrip(page, input, filter, ongoing ?? "", createdOnly);
  return response;
});

export const getAllCompletedTripsThunk = createAsyncThunk<any, any, { state: RootState }>("trip/completed-trip", async ({ page }: { page: number }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getAllCompletedTrips(page);
  return response;
});

//get new bids information
export const getNewBidsThunk = createAsyncThunk<any, { page: number; input?: string; filter: string }>("user/getNewBidsThunk", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getNewBids(page, input, filter);
});

export const getAvailableVehicleForBiddingThunk = createAsyncThunk<any, { id: number }>("fleet/get-availabl-vehicle-for", async ({ id }: { id: number }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getAvailableVehicleForBidding(id);
});

//place new bid
export const newBidRequestThunk = createAsyncThunk<any, { state: RootState }>("fleet/newBidRequestThunk", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.newBidRequest(values);
});

//get rejected bids information
export const getRejectedBidsThunk = createAsyncThunk<any, { page: number; input: string; filter?: string }>("user/getRejectedBidsThunk", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getRejectedBids(page, input, filter);
});

//get accepted bids information
export const getAcceptedBidsThunk = createAsyncThunk<any, { page: number; input?: string; filter?: string }>("user/getAcceptedBidsThunk", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getAcceptedBids(page, input, filter);
});

export const acknowledgeDigitalContractThunk = createAsyncThunk<any, { state: RootState }>("fleet/acknowledgeDigitalContractThunk", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.acknowledgeDigitalContract(values);
});

export const acknowledgeContractThunk = createAsyncThunk<any, any, { state: RootState }>("fleet/acknowledgeContractThunk", async (id: number) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.acknowledgeContract(id);
});

//cancel bid
export const cancelBidRequesthunk = createAsyncThunk<any, { state: RootState }>("fleet/cancelBidThunk", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.cancelBidRequest(values);
});

//payment
export const createPaymentThunk = createAsyncThunk<any, { state: RootState }>("fleet/createPayment", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.userPayment(values);
});

export const createTransactionPaymentThunk = createAsyncThunk<any, { state: RootState }>("fleet/transactionPayment", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.transactionPayment(values);
});

export const cancelOrderhunk = createAsyncThunk<any, { state: RootState }>("fleet/cancelOrderRequesthunk", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.cancelOrder(values);
});

export const getAllVehiclesForLiveTracking = createAsyncThunk<any>("fleet/getAllVehiclesForLiveTracking", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getAllVehicles();
});

export const getVehicleCheckListThunk = createAsyncThunk<any, { page: number; input: string; filter?: string }, { state: RootState }>("fleet/getVehicleChecklist", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getVehicleCheckList(page, input, filter ? `&${filter}` : "");
  return response.data;
});

export const getVehicleLogHistoryThunk = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("fleet/getVehicleLogHistory", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getVehicleLogHistory(page, input, filter);
  return response.data;
});

export const getDeclinedVehicleReport = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("fleet/getDeclinedVehicleReport", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getDeclinedVehicleReport(page, input, filter);
  return response.data;
});

export const getRejectedVehicleReport = createAsyncThunk<any, { page: number; input: string }, { state: RootState }>("fleet/getRejectedVehicleReport", async ({ page, input }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getRejectedVehicleReport(page, input);
  return response.data;
});

export const getEditRequestVehicleReport = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("fleet/getEditRequestVehicleReport", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getEditRequestVehicleReport(page, input, filter);
  return response.data;
});

export const getAwaitingApprovalVehicleReport = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("fleet/getAwaitingApprovalVehicleReport", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAwaitingApprovalVehicleReport(page, input, filter);
  return response.data;
});

export const getTQMSPendingVehicles = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("fleet/getTQMSPendingVehicles", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getTQMSPendingVehicles(page, input, filter);
  return response.data;
});

export const getLoadBoardPendingVehicles = createAsyncThunk<any, { page: number; input: string; filter: string }, { state: RootState }>("fleet/getLoadBoardPendingVehicles", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getLoadBoardPendingVehicles(page, input, filter);
  return response.data;
});

export const getAwaitingApprovalDriverReportThunk = createAsyncThunk<any, { type: string; page: number; input: string }, { state: RootState }>("fleet/getAwaitingApprovalDriverReport", async ({ type, page, input }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAwaitingApprovalDriverReport(type, page, input);
  return response.data;
});
export const getStatusDriverReportThunk = createAsyncThunk<any, { state: RootState }>("fleet/getStatusDriverReport", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getStatusDriverReport(values);
  return response.data;
});

export const getStatusVehicleReportThunk = createAsyncThunk<any, { values: any; id: string }, { state: RootState }>("fleet/getStatusVehicleReport", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getStatusVehicleReport(values);
  return response.data;
});

export const getInsuranceCompanyThunk = createAsyncThunk<any, void, { state: RootState }>("vehicle/getInsuranceCompany", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getInsuranceCompany();
  return response;
});

export const checkUniqueVehicleNumber = createAsyncThunk<any, any, { state: RootState }>("vehicle/checkUniqueVehicleNumber", async (vehicleNumber) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.checkUniqueVehicleNumber(vehicleNumber);
  return response;
});

export const getProformaInvoiceThunk = createAsyncThunk<any, any, { state: RootState }>("payment/getProformaInvoice", async (id) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getProformaInvoice(id);
  return response;
});

export const getUnassignedDriverThunk = createAsyncThunk<any>("user/getUnassignedDriver", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getUnAssignedDriver();
});

export const getAllDriversOfVehicleThunk = createAsyncThunk<any, number>("user/getAllDriversForVehicle", async (vehicleId: number) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getAllDriversOfVehicle(vehicleId);
});

export const updateVehicleStatusThunk = createAsyncThunk<any, { id: number; values: FleetUseCase }>("fleet/vehicle-status-update", async ({ id, values }: { id: number; values: any }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.updateVehicleStatus(id, values);
});

export const assignDriverThunk = createAsyncThunk<any, { state: RootState }>("fleet/assign-driver-to-vehicle", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const data = await useCase.assignDriver(values);
  return data;
});

export const getOrderBidDetails = createAsyncThunk<any, { id: number }>("fleet/getOrderBidsDetails", async ({ id }: { id: number }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getOrderBidDetails(id);
});

export const updatePlanFeaturesThunk = createAsyncThunk<any, { planId: number; featureIds: number[] }>("fleet/updatePlanFeatures", async ({ planId, featureIds }: { planId: number; featureIds: number[] }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.updatePlanFeatures(planId, featureIds);
});

//for getting onboarding data of vehicle, driver and vehicle owner
export const getOnBoardingDataThunk = createAsyncThunk<
  any,
  {
    status: string;
    type: string;
    page: number;
    input: string;
  },
  { state: RootState; rejectValue: { message: string } }
>("fleet/onboarding", async ({ status, type, page, input }, { rejectWithValue }) => {
  try {
    const useCase = fleetModuleContainer.getProvided(FleetUseCase);
    const response = await useCase.getOnboardingData(status, type, page, input);
    if (!response.success) {
      return rejectWithValue(response);
    }

    return response;
  } catch (error: any) {
    return rejectWithValue({
      message: error.message || "Failed to fetch data.",
    });
  }
});

export const getVehicleOnBoardingListsThunk = createAsyncThunk<any, { page: number; input: string; filter: string; status?: string }>("fleet/getVehicleOnBoardingLists", async ({ page, input, filter, status }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getVehicleOnBoardingLists(page, input, filter, status);
});

export const setVehicleEditOnBoardingThunk = createAsyncThunk<any, { id: number; value: any }>("fleet/setVehicleEditOnBoarding", async ({ id, value }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.setVehicleEditOnBoarding(id, value);
});

export const getVehicleDetailsByIdThunk = createAsyncThunk<any, { vehicleId: number }, { state: RootState }>("fleet/getVehicleDetails", async (value) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getVehicleDetailsById(value);
});

export const getSthaniyaThunk = createAsyncThunk<any, void, { state: RootState }>("vehicle/getSthaniyaThunk", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getSthaniya();
  return response;
});

export const getTQMSVehicleDetailsThunk = createAsyncThunk<any, { id: number }, { state: RootState }>("users/tqmsVehicle-details", async ({ id }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getTQMSVehicleDetails(id);
  return response;
});

export const getPendingVehicleDetailsThunk = createAsyncThunk<any, { id: number }, { state: RootState }>("users/tqmsVehicle-details", async ({ id }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getPendingVehicleDetails(id);
  return response;
});

export const messageReceivedFromSocketThunk = createAsyncThunk<any, { state: RootState }>("socket/message-received-remote", async (values: any) => {
  return;
});

export const shipmentTrackingSocketThunk = createAsyncThunk<any, { state: RootState }>("socket/shipment-tracking", async (values: any) => {
  return;
});

//Get the details of single trip
export const getTripActualPathThunk = createAsyncThunk<any, { id: number }>("fleet/getTrip-path", async ({ id }: { id: number }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getTripActualPath(id);
});

//get pending vehicles
export const getPendingApprovalVehiclesThunk = createAsyncThunk<any, { page: number; input: string; filter: string; status: string }>("fleet/getPendingApprovalVehiclesThunk", async ({ page, input, filter, status }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getPendingApprovalVehicles(page, input, filter, status);
});

export const acceptrejectvehicle = createAsyncThunk<any, { state: RootState }>("fleet/acceptrejectvehicle", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.acceptrejectvehicle(values);
});

export const getAVehicleChangeRequestById = createAsyncThunk<any, any, { state: RootState }>("trip/vehicleShiftChangeRequestsById", async (id: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getAVehicleChangeRequestById(id);
  return response.data;
});

export const getAllVirtualCheckpointThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/virtual-checkpoint", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getAllVirtualCheckpoints(page, input, filter);
  return response;
});

export const createVirtualCheckpointThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/createVirtualCheckpoint", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.createVirtualCheckpoint(values);
  return response;
});

export const updateVirtualCheckpointThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/updateVirtualCheckpoint", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.updateVirtualCheckpoint(id, values);
  return response;
});

export const deleteVirtualCheckpointThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/deleteVirtualCheckpoint", async (id: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.deleteVirtualCheckpoint(id);
  return response;
});

export const getPaymentDetailsThunk = createAsyncThunk<any, any, { state: RootState }>("payment/paymnt-details", async (id: string) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getPaymentDetails(id);
  return response.data;
});

export const getNepalPaymentDetailsThunk = createAsyncThunk<any, any, { state: RootState }>("payment/paymnt-details", async (id: string) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getNepalPayDetails(id);
  return response.data;
});

export const getVehiclePlanTrendThunk = createAsyncThunk<any, { page: number; input: string; filter: string; vehicleId: number }, { state: RootState }>("auth/vehicles-plans-trend", async ({ page, input, filter, vehicleId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getVehiclePlanTrend(page, input, filter, vehicleId);
  return response;
});

export const getVehicleScheduledPlanThunk = createAsyncThunk<any, { page: number; input: string; filter: string; vehicleId: number }, { state: RootState }>("auth/vehicles-scheduled-plans", async ({ page, input, filter, vehicleId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getVehicleScheduledPlan(page, input, filter, vehicleId);
  return response;
});

// Add getCancelledPlanThunk
export const getCancelledPlanThunk = createAsyncThunk<any, { vehicleId: number }, { state: RootState }>("fleet/getCancelledPlan", async ({ vehicleId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getCancelledPlan(vehicleId);
});

//Contract Owner
export const updateContractVehicleThunk = createAsyncThunk<any, any, { state: RootState }>("vehicle/update-contract", async ({ id, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.updateContractVehicle(id, values);
  return response.data;
});

// Add a new action to clear vehicles data
const clearVehiclesData = createAction("fleet/clearVehiclesData");

export const getContractHistoryThunk = createAsyncThunk<any, { vehicleId: number }, { state: RootState }>("vehicle/getTripCoordinates", async ({ vehicleId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = useCase.getVehicleContractHistory(vehicleId);
  return response;
});

export const getCancelledBidsThunk = createAsyncThunk<any, { page: number; input: string; filter?: string }>("user/getCancelledBidsThunk", async ({ page, input, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getCancelledBids(page, input, filter);
});

// Add cancelSubscriptionThunk to fleet module
export const cancelSubscriptionThunk = createAsyncThunk<
  any,
  {
    vehicleId: number;
    data: { documentId?: number; additionalDetails?: string };
  },
  { state: RootState }
>("fleet/cancelSubscription", async ({ vehicleId, data }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.cancelSubscription(vehicleId, data);
  return response;
});

export const getApplicableCancellationPolicyThunk = createAsyncThunk<any, { vehicleId: number }>("fleet/getApplicableCancellationPolicy", async ({ vehicleId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getApplicableCancellationPolicy(vehicleId);
});

export const getSubscriptionExpiryRemindersThunk = createAsyncThunk<any, void, { state: RootState }>("fleet/getSubscriptionExpiryReminders", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getSubscriptionExpiryReminders();
});

export const updateSubscriptionExpiryReminderThunk = createAsyncThunk<any, { reminderId: number; remindBeforeDays: number }, { state: RootState }>("fleet/updateSubscriptionExpiryReminder", async ({ reminderId, remindBeforeDays }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.updateSubscriptionExpiryReminder(reminderId, {
    remindBeforeDays,
  });
});

const updatePlan = async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  try {
    const data = await useCase.updatePlan(values);
    return data;
  } catch (error) {
    return error;
  }
};

export const togglePaymentStatusThunk = createAsyncThunk<any, any, { state: RootState }>("fleet/UpdatePaymentStatusThunk", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.updatePaymentStatus(values);
});

export const verifyPromoCodeThunk = createAsyncThunk<any, { values: any }>("fleet/verifyPromoCode", async ({ values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.verifyPromoCode(values);
});

export const getApplicablePromoCodeThunk = createAsyncThunk<any, { page: number; limit?: number; search?: string; filter?: string }>("fleet/getApplicablePromoCode", async ({ page, limit, search, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getApplicablePromoCode(page, limit, search, filter);
});

export const getAppliedPromoCodeThunk = createAsyncThunk<any, { page: number; limit?: number; search?: string; filter?: string }>("fleet/getAppliedPromoCode", async ({ page, limit, search, filter }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getAppliedPromoCode(page, limit, search, filter);
});

export const getLiveShipmentTrackThunk = createAsyncThunk("order/getLiveShipmentTrack", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  const response = await useCase.getLiveShipmentTrack();
  return response;
});

export const getPaymentLogsThunk = createAsyncThunk("fleet/getPaymentLogs", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getPaymentLogs(values);
});

export const getCommissionReportThunk = createAsyncThunk("fleet/getCommissionReport", async (values: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getCommissionReport(values);
});

export const getUnassignedDriverThunkV2 = createAsyncThunk<any, { vehicleId: number }>("user/getUnassignedDriverV2", async ({ vehicleId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getUnassignedDriverV2(vehicleId);
});

export const getUnassignedVehicleThunkV2 = createAsyncThunk<any, { driverId: number }>("user/getUnassignedVehicleV2", async ({ driverId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getUnassignedVehicleV2(driverId);
});

export const getSearchVehicleThunk = createAsyncThunk<any, any, { state: RootState }>("fleet/getSearchVehicle", async (query: any) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getSearchVehicle(query);
});

export const vehicleActionThunk = createAsyncThunk<any, { vehicleId: number; values: any }, { state: RootState }>("fleet/vehicleAction", async ({ vehicleId, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.vehicleAction(vehicleId, values);
});

export const shiftVehicleOwnerThunk = createAsyncThunk<any, { vehicleId: number; values: any }, { state: RootState }>("fleet/shiftVehicleOwner", async ({ vehicleId, values }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.shiftVehicleOwnerThunk(vehicleId, values);
});

export const getVehicleStatusThunk = createAsyncThunk("user/getVehicleStatusThunk", async () => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.getAllVehicleStatus();
});

export const updateEligibleVehicleStatusThunk = createAsyncThunk<any, { vehicleStatusId: number }>("user/getUnassignedVehicleV2", async ({ vehicleStatusId }) => {
  const useCase = fleetModuleContainer.getProvided(FleetUseCase);
  return await useCase.updateEligibleVehicleStatus(vehicleStatusId);
});

export const fleetSlice = createSlice({
  name: "fleet",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllVechilesThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicles = action?.payload?.data?.data?.vehicles;
        state.vehicleCount = action?.payload?.data?.data?.count;
      })
      .addCase(getAllVechilesThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllVechilesThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAllChangeShiftRequestsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.shiftChangeRequests = action.payload.data.data;
        state.shiftChangeRequestsCount = action.payload.data.data?.count;
      })

      .addCase(getAllVehiclesOfDriverThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicles = action?.payload?.data?.data;
        state.vehicleCount = action?.payload?.data?.data?.count;
      })
      .addCase(getAllVehiclesOfDriverThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllVehiclesOfDriverThunk.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getAllCompletedTripsThunk.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllCompletedTripsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.completedTrips = action.payload?.data?.completedTrips;
        state.completedTripsCount = action.payload?.data?.count;
      })
      .addCase(getAllCompletedTripsThunk.rejected, (state, action) => {
        state.isLoading = false;
      })

      .addCase(getAllTripThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.trips = action.payload?.data?.trips;
        state.tripCount = action.payload?.data?.count;
      })
      .addCase(getAllTripThunk.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllTripThunk.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getAVehicleThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicle = action.payload.data.data;
      })

      .addCase(transferOwnershipThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        const updatedData = action.payload.data;
        const index = state.vehicles.findIndex((vehicle: any) => vehicle.vehicleId === updatedData.vehicleId);
        if (index !== -1) {
          state.vehicles[index].vehicleOwner = updatedData.vehicleOwner;
        }
      })
      .addCase(transferOwnershipThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getAVehicleThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(deleteVehicleThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const vehicleId = action.meta.arg;
        state.vehicles = state?.vehicles?.filter((vehicle: any) => vehicle.vehicleId !== vehicleId);
      })
      .addCase(deleteVehicleThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getATripThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.tripDetails = action.payload.data.data;
      })
      .addCase(getATripThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getATripThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(deleteTripThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const tripId = action.meta.arg;
        state.trips = state?.trips?.filter((trip: any) => trip.tripId !== tripId);
      })
      .addCase(deleteTripThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      });

    builder
      .addCase(getAllVehicleCategoryThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicleCategories = action?.payload?.data?.data;
        state.VehicleCategoryCount = action.payload?.data?.data?.count;
      })
      .addCase(getAllVehicleCategoryThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })

      .addCase(deleteVehicleCategoryThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const vehicleCategoryId = action.meta.arg;
        if (action?.payload?.success) {
          state.vehicleCategories = action?.payload?.data;
        }
      })
      .addCase(deleteVehicleCategoryThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getVehicleCategoryThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicleCategory = action.payload.data.data;
      })
      .addCase(getVehicleCategoryThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getUnitsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.units = action.payload.data;
      })
      .addCase(getUnitsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(createUnitThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.units = [...state.units, action.payload.data];
      })
      .addCase(createUnitThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })

      .addCase(getAllVehicleTypesThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicleTypes = action.payload.data;
        state.vehicleTypeCount = action.payload.data.count;
      })
      .addCase(getAllVehicleTypesThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })

      .addCase(deleteVehicleTypeThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const vehicleTypeId = action.meta.arg;
        if (action?.payload?.success) {
          state.vehicleTypes = action?.payload?.data;
        }
      })
      .addCase(deleteVehicleTypeThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getVehicleTypeThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicleType = action.payload.data.data;
      })
      .addCase(getVehicleTypeThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getAllVehicleOwnerList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehicleOwnerLists = action?.payload;
      })
      .addCase(getAllVehicleOwnerList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getAllVehiclePlateColorsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehiclePlateColors = action?.payload.data;
      })
      .addCase(getAllVehiclePlateColorsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getVehiclePolicyTypesThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.vehiclePolicyTypes = action?.payload.data;
      })
      .addCase(getVehiclePolicyTypesThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getInsuranceCompanyThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.insuranceCompany = action?.payload.data;
      })
      .addCase(getInsuranceCompanyThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      })
      .addCase(getSthaniyaThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.sthaniya = action?.payload.data;
      })
      .addCase(getSthaniyaThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      });

    builder.addCase(getNewBidsThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.newBidsInformation = action?.payload?.data?.bidRequest;
      state.newBidsInformationCount = action?.payload?.data?.count;
    });
    builder.addCase(getNewBidsThunk.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });
    builder.addCase(newBidRequestThunk.fulfilled, (state, action) => {
      if (action?.payload?.data?.data?.bidRequest) {
        state.newBidsInformation = action?.payload?.data?.data?.bidRequest;
      }
    });
    builder.addCase(newBidRequestThunk.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });

    builder.addCase(getAcceptedBidsThunk.fulfilled, (state, action) => {
      // state.acceptedBidsInformation = action?.payload?.data?.bidRequest;
      state.acceptedBidsInformation = action?.payload?.data;
      state.acceptedBidsInformationCount = action?.payload?.data?.count;
    });
    builder.addCase(getAcceptedBidsThunk.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });

    builder.addCase(getRejectedBidsThunk.fulfilled, (state, action) => {
      state.rejectedBidsInformation = action?.payload?.data?.bidRequest;
      state.rejectedBidsInformationCount = action?.payload?.data?.count;
    });
    builder.addCase(getRejectedBidsThunk.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });

    builder.addCase(getAllVehiclesForLiveTracking.fulfilled, (state, action) => {
      state.vehiclesForTracking = action.payload.data;
    });
    builder.addCase(getAllVehiclesForLiveTracking.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });

    builder
      .addCase(getVehicleCheckListThunk.fulfilled, (state, action) => {
        state.vehicleChecklist = action?.payload?.data;
        state.vehicleChecklistCount = action?.payload?.data?.count;
      })
      .addCase(getVehicleCheckListThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });

    builder
      .addCase(getVehicleLogHistoryThunk.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVehicleLogHistoryThunk.fulfilled, (state, action) => {
        state.vehicleLogHistory = action?.payload?.data?.tripData;
        state.vehicleLogHistoryCount = action?.payload?.data?.count;
        state.isLoading = false;
      })
      .addCase(getVehicleLogHistoryThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
        state.isLoading = false;
      });

    builder
      .addCase(getDeclinedVehicleReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDeclinedVehicleReport.fulfilled, (state, action) => {
        state.declinedVehicleReport = action?.payload?.data?.vehicles;
        state.declinedVehicleReportCount = action?.payload?.data?.count;
        state.isLoading = false;
      })
      .addCase(getDeclinedVehicleReport.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
        state.isLoading = false;
      });
    builder
      .addCase(getRejectedVehicleReport.fulfilled, (state, action) => {
        state.rejectedVehicleReport = action?.payload?.data?.vehicles;
        state.rejectedVehicleReportCount = action?.payload?.data?.count;
      })
      .addCase(getRejectedVehicleReport.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });

    builder
      .addCase(getEditRequestVehicleReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getEditRequestVehicleReport.fulfilled, (state, action) => {
        state.editRequestvehicleReport = action?.payload?.data?.vehicles;
        state.editRequestvehicleReportCount = action?.payload?.data?.count;
        state.isLoading = false;
      })
      .addCase(getEditRequestVehicleReport.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
        state.isLoading = false;
      });

    builder
      .addCase(getAwaitingApprovalVehicleReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAwaitingApprovalVehicleReport.fulfilled, (state, action) => {
        state.awaitingApprovalVehicleReport = action?.payload?.data?.vehicles;
        state.awaitingApprovalVehicleReportCount = action?.payload?.data?.count;
        state.isLoading = false;
      })
      .addCase(getAwaitingApprovalVehicleReport.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
        state.isLoading = false;
      });

    builder
      .addCase(getTQMSPendingVehicles.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTQMSPendingVehicles.fulfilled, (state, action) => {
        if (action.payload.skipStateUpdate) {
          return state;
        }
        state.tqmsPendingVehicles = action?.payload?.data?.vehicles;
        state.tqmsPendingVehiclesCount = action?.payload?.data?.count;
        state.isLoading = false;
      })
      .addCase(getTQMSPendingVehicles.rejected, (state, action) => {
        state.error = action.error?.message;
        console.error(action.error?.message || "unknown error");
      });

    builder
      .addCase(getLoadBoardPendingVehicles.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLoadBoardPendingVehicles.fulfilled, (state, action) => {
        state.loadBoardPendingVehicles = action?.payload?.data?.vehicles;
        state.loadBoardPendingVehiclesCount = action?.payload?.data?.count;
        state.isLoading = false;
      })
      .addCase(getLoadBoardPendingVehicles.rejected, (state, action) => {
        state.error = action.error?.message;
        console.error(action.error?.message || "unknown error");
      });

    builder
      .addCase(getAwaitingApprovalDriverReportThunk.fulfilled, (state, action) => {
        state.awaitingApprovalDriverReport = action?.payload?.data;
        state.awaitingApprovalDriverReportCount = action?.payload?.data?.count;
      })
      .addCase(getAwaitingApprovalDriverReportThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });
    builder
      .addCase(updateTripStatusThunk.fulfilled, (state, action) => {
        const resData = action?.payload?.data;
        state.tripDetails.tripStatus = resData?.tripStatus;
      })
      .addCase(updateTripStatusThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });
    builder
      .addCase(getStatusDriverReportThunk.fulfilled, (state: any, action: any) => {
        if (action?.payload?.success) {
          const { tqmsId } = action.meta.arg;
          state.tqmsOnBoardingData = state?.tqmsOnBoardingData?.filter((data: any) => {
            return Number(data.tqmsUserId) !== tqmsId;
          });
        }
      })
      .addCase(getStatusDriverReportThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });

    builder
      .addCase(getStatusVehicleReportThunk.fulfilled, (state: any, action: any) => {
        if (action?.payload?.success) {
          const { tqmsId } = action.meta.arg;
          state.awaitingApprovalVehicleReport = state?.awaitingApprovalVehicleReport.filter((data: any) => {
            return Number(data.tqmsFleetId) !== tqmsId;
          });
        }
      })
      .addCase(getStatusVehicleReportThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });

    builder
      .addCase(getUnassignedDriverThunk.fulfilled, (state, action) => {
        state.unAssignedDriver = action.payload.data;
      })
      .addCase(getUnassignedDriverThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });

    builder
      .addCase(getAllDriversOfVehicleThunk.fulfilled, (state, action) => {
        const response = action.payload.data;
        const unassignedDrivers = response.filter((driver: any) => driver.vehicle === null);
        state.unAssignedDriver = unassignedDrivers;
      })
      .addCase(getAllDriversOfVehicleThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });

    builder
      .addCase(assignDriverThunk.fulfilled, (state, action) => {
        if (!!action?.payload?.success) {
          const updatedVehicle = action.payload.data;
          const index = state.vehicles.findIndex((vehicle: any) => vehicle?.vehicleId === updatedVehicle?.vehicleId);

          if (index !== -1) {
            state.vehicles[index] = updatedVehicle;
          }
        }
      })
      .addCase(assignDriverThunk.rejected, (state, action) => {
        console.error(action.error.message || "unknown error");
      });

    builder.addCase(updateVehicleStatusThunk.fulfilled, (state, action) => {
      const updatedVehicle = action.payload.data;

      const index = state.vehicles.findIndex((vehicle: any) => vehicle.vehicleId === updatedVehicle.vehicleId);

      if (index !== -1) {
        state.vehicles[index].vehicleStatus = updatedVehicle?.vehicleStatus;
      }
    });
    builder.addCase(updateVehicleStatusThunk.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });

    builder
      .addCase(getOnBoardingDataThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getOnBoardingDataThunk.fulfilled, (state, action) => {
        const responseData = action?.payload?.data?.tqmsUsers;
        const responseDataCount = action?.payload?.data?.count;
        state.tqmsOnBoardingData = responseData;
        state.tqmsOnBoardingDataCount = responseDataCount;
        state.isLoading = false;
      })
      .addCase(getOnBoardingDataThunk.rejected, (state, action) => {
        state.isLoading = false;
        const errorMessage = action?.payload?.message || action?.error?.message || "unknown error";
        message.error(errorMessage);
        console.error(errorMessage);
      });

    builder
      .addCase(getVehicleOnBoardingListsThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getVehicleOnBoardingListsThunk.fulfilled, (state, action) => {
        const responseData = action?.payload?.data.vehicles;
        const responseDataCount = action?.payload?.data?.count;
        state.vehicleOnBoardingList = responseData;
        state.vehicleOnBoardingListCount = responseDataCount;
        state.isLoading = false;
      })
      .addCase(getVehicleOnBoardingListsThunk.rejected, (state, action) => {
        state.isLoading = false;
        message.error(action?.error?.message || "unknown error");
        console.error(action.error.message || "unknown error");
      });
    builder.addCase(messageReceivedFromSocketThunk.fulfilled, (state, action) => {
      const socketData: any = action?.meta?.arg;
      if (socketData?.content?.vehicleId) {
        const vehicleIndex = state?.vehiclesForTracking?.findIndex((vehicle: any) => vehicle?.vehicleId === socketData?.content?.vehicleId);

        if (vehicleIndex !== -1) {
          const newCoordinates = socketData?.content?.location?.coordinates;
          state.vehiclesForTracking[vehicleIndex] = {
            ...state?.vehiclesForTracking?.[vehicleIndex],
            latitude: newCoordinates?.[0],
            longitude: newCoordinates?.[1],
            deviceCreatedAt: socketData?.content?.updateAt,
            heading: socketData?.content?.heading,
            speed: socketData?.content?.speed,
            tripId: socketData?.content?.tripId || null,
          };
        }
      }
    });
    builder.addCase(messageReceivedFromSocketThunk.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });
    builder.addCase(shipmentTrackingSocketThunk.fulfilled, (state, action) => {
      const socketData: any = action?.meta?.arg;
      if (socketData?.content?.vehicleId) {
        const vehicleIndex = state?.liveShipments?.findIndex((vehicle: any) => vehicle?.vehicleId === socketData?.content?.vehicleId);

        if (vehicleIndex > -1) {
          const newCoordinates = socketData?.content?.location?.coordinates;
          state.liveShipments[vehicleIndex] = {
            ...state?.liveShipments?.[vehicleIndex],
            latitude: newCoordinates?.[0],
            longitude: newCoordinates?.[1],
            deviceCreatedAt: socketData?.content?.updateAt,
            heading: socketData?.content?.heading,
            speed: socketData?.content?.speed,
            tripId: socketData?.content?.tripId || null,
          };
        }
      }
    });
    builder.addCase(shipmentTrackingSocketThunk.rejected, (state, action) => {
      console.error(action?.error?.message || "unknown error");
    });
    builder
      .addCase(getPendingApprovalVehiclesThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPendingApprovalVehiclesThunk.fulfilled, (state, action) => {
        const responseData = action?.payload?.data?.vehicles;
        const responseDataCount = action?.payload?.data?.count;
        state.pendingApprovalList = responseData;
        state.pendingApprovalListCount = responseDataCount;
        state.isLoading = false;
      })
      .addCase(getPendingApprovalVehiclesThunk.rejected, (state, action) => {
        state.isLoading = false;
        message.error(action?.error?.message || "unknown error");
        console.error(action.error.message || "unknown error");
      });
    builder.addCase(acceptrejectvehicle.fulfilled, (state, action: any) => {
      const vehicleId = action?.meta?.arg?.vehicleId;
      state.pendingApprovalList = state.pendingApprovalList.filter((vehicle: any) => vehicle.vehicleId !== vehicleId);
    });
    builder.addCase(acceptrejectvehicle.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });
    builder.addCase(getAVehicleChangeRequestById.fulfilled, (state, action) => {
      state.error = null;
      state.vehicleShiftRequestDetails = action.payload.data;
    });
    builder
      .addCase(getAllVirtualCheckpointThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAllVirtualCheckpointThunk.fulfilled, (state, action) => {
        const responseData = action?.payload?.data?.data?.allCheckpoints;
        const responseDataCount = action?.payload?.data?.data?.count;
        state.virtualCheckpointList = responseData;
        state.virtualCheckpointCount = responseDataCount;
        state.isLoading = false;
      })
      .addCase(getAllVirtualCheckpointThunk.rejected, (state, action) => {
        state.isLoading = false;
        message.error(action?.error?.message || "unknown error");
        console.error(action.error.message || "unknown error");
      })
      .addCase(deleteVirtualCheckpointThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const virtualCheckpointId = action.meta.arg;
        state.virtualCheckpointList = state?.virtualCheckpointList?.filter((virtualCheckpoint: any) => virtualCheckpoint.virtualCheckpointId !== virtualCheckpointId);
      });
    // Add this case to handle clearing vehicles data
    builder.addCase(clearVehiclesData, (state) => {
      state.vehicles = [];
      state.vehicleCount = 0;
      state.isLoading = false;
      state.error = null;
    });

    builder.addCase(getCancelledBidsThunk.fulfilled, (state, action) => {
      state.cancelledBidsInformation = action?.payload?.data?.rejectedBids;
      state.cancelledBidsInformationCount = action?.payload?.data?.count;
    });
    builder.addCase(getCancelledBidsThunk.rejected, (state, action) => {
      console.error(action.error.message || "unknown error");
    });
    builder
      .addCase(getSubscriptionExpiryRemindersThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSubscriptionExpiryRemindersThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionExpiryReminders = action.payload?.data?.data || [];
      })
      .addCase(getSubscriptionExpiryRemindersThunk.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateSubscriptionExpiryReminderThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSubscriptionExpiryReminderThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // Optionally update the state.subscriptionExpiryReminders here if needed
      })
      .addCase(updateSubscriptionExpiryReminderThunk.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(verifyPromoCodeThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.verifyPromoCode = action?.payload?.data;
      })
      .addCase(verifyPromoCodeThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      });

    builder
      .addCase(getApplicablePromoCodeThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getApplicablePromoCodeThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.applicablePromoCodes = action?.payload?.data?.promotion;
        state.applicablePromoCount = action?.payload?.data?.count;
      })
      .addCase(getApplicablePromoCodeThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      });

    builder
      .addCase(getAppliedPromoCodeThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAppliedPromoCodeThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appliedPromoCodes = action?.payload?.data?.promotion;
        state.appliedPromoCount = action?.payload?.data?.count;
      })
      .addCase(getAppliedPromoCodeThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Unknown error";
      });

    builder
      .addCase(getLiveShipmentTrackThunk.pending, (state) => {
        state.isLiveShipmentsLoading = true;
      })
      .addCase(getLiveShipmentTrackThunk.fulfilled, (state, action) => {
        state.isLiveShipmentsLoading = false;
        state.error = null;
        state.liveShipments = action?.payload?.data?.data || [];
      })
      .addCase(getLiveShipmentTrackThunk.rejected, (state, action) => {
        state.isLiveShipmentsLoading = false;
        state.error = action.error.message || "Unknown error";
      });

    builder
      .addCase(getPaymentLogsThunk.pending, () => {})
      .addCase(getPaymentLogsThunk.fulfilled, (state, action) => {
        return action?.payload?.data;
      })
      .addCase(getPaymentLogsThunk.rejected, () => {});

    builder
      .addCase(getCommissionReportThunk.pending, () => {})
      .addCase(getCommissionReportThunk.fulfilled, (state, action) => {
        return action?.payload?.data;
      })
      .addCase(getCommissionReportThunk.rejected, () => {});
  },
});

export const userSelectors = {};

export const fleetActions = fleetSlice.actions;

export const fleetThunks = {
  // ...existing thunks
  getAllDriversOfVehicleThunk,
  createVehicleCategoryThunk,
  getAllVechilesThunk,
  getAllVehiclesOfDriverThunk,
  getAllVehicleCategoryThunk,
  deleteVehicleCategoryThunk,
  getVehicleCategoryThunk,
  updateVehicleCategoryThunk,
  getUnitsThunk,
  createUnitThunk,
  createVehicleTypesThunk,
  updateVehicleTypesThunk,
  getAllVehicleTypesThunk,
  getVehicleTypeThunk,
  deleteVehicleTypeThunk,
  getAllVehicleOwnerList,
  deleteVehicleThunk,
  getTripCoordinatesById,
  getAVehicleThunk,
  updateVehicleThunk,
  getAllVehiclePlateColorsThunk,
  getVehiclePolicyTypesThunk,
  checkVehicleExistanceThunk,
  createVehicleThunk,
  createTripThunk,
  getAllTripThunk,
  getATripThunk,
  deleteTripThunk,
  updateTripStatusThunk,
  updateTripThunk,
  getAvailableVehicleForBiddingThunk,
  getNewBidsThunk,
  newBidRequestThunk,
  getRejectedBidsThunk,
  getAcceptedBidsThunk,
  acknowledgeDigitalContractThunk,
  cancelBidRequesthunk,
  createPaymentThunk,
  createTransactionPaymentThunk,
  transferOwnershipThunk,
  getAllChangeShiftRequestsThunk,
  changeVehicleOwnThunk,
  changeVehicleOthersThunk,
  cancelOrderhunk,
  changeVehicleRequestStatusThunk,
  getAllVehiclesForLiveTracking,
  getVehicleCheckListThunk,
  getVehicleLogHistoryThunk,
  getDeclinedVehicleReport,
  getEditRequestVehicleReport,
  getAwaitingApprovalVehicleReport,
  getAwaitingApprovalDriverReportThunk,
  getStatusDriverReportThunk,
  getStatusVehicleReportThunk,
  getInsuranceCompanyThunk,
  checkUniqueVehicleNumber,
  getUnassignedDriverThunk,
  assignDriverThunk,
  updateVehicleStatusThunk,
  getOrderBidDetails,
  acknowledgeContractThunk,
  getOnBoardingDataThunk,
  getVehicleOnBoardingListsThunk,
  setVehicleEditOnBoardingThunk,
  getVehicleDetailsByIdThunk,
  getSthaniyaThunk,
  getProformaInvoiceThunk,
  getRejectedVehicleReport,
  getTQMSVehicleDetailsThunk,
  messageReceivedFromSocketThunk,
  shipmentTrackingSocketThunk,
  getTQMSPendingVehicles,
  getLoadBoardPendingVehicles,
  getAllCompletedTripsThunk,
  getPendingVehicleDetailsThunk,
  getTripActualPathThunk,
  getPendingApprovalVehiclesThunk,
  acceptrejectvehicle,
  getAVehicleChangeRequestById,
  getAllVirtualCheckpointThunk,
  createVirtualCheckpointThunk,
  updateVirtualCheckpointThunk,
  deleteVirtualCheckpointThunk,
  getPaymentDetailsThunk,
  getNepalPaymentDetailsThunk,
  getVehiclePlanTrendThunk,
  getVehicleScheduledPlanThunk,
  getCancelledPlanThunk,
  updateContractVehicleThunk,
  clearVehiclesData,
  getContractHistoryThunk,
  getCancelledBidsThunk,
  cancelSubscriptionThunk,
  getApplicableCancellationPolicyThunk,
  getSubscriptionExpiryRemindersThunk,
  updateSubscriptionExpiryReminderThunk,
  updatePlan,
  togglePaymentStatusThunk,
  verifyPromoCodeThunk,
  getAppliedPromoCodeThunk,
  getApplicablePromoCodeThunk,
  getLiveShipmentTrackThunk,
  getPaymentLogsThunk,
  getCommissionReportThunk,
  getUnassignedDriverThunkV2,
  getUnassignedVehicleThunkV2,
  getSearchVehicleThunk,
  vehicleActionThunk,
  shiftVehicleOwnerThunk,
  getVehicleStatusThunk,
  updateEligibleVehicleStatusThunk,
  updatePlanFeaturesThunk,
};

export const fleetReducer = fleetSlice.reducer;
